import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import { SVGProps } from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const TextIcon: React.FC<IconProps & SVGProps<SVGSVGElement>> = ({
  color = "#fd6a65",
  withBackground,
  ...rest
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g fill={color}>
            <path
              d="M6.75 13.15c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v4.949c0 .978 0 1.468-.11 1.928-.098.408-.26.798-.48 1.156-.247.404-.593.75-1.284 1.442l-.251.25c-.692.692-1.038 1.038-1.442 1.286-.358.219-.748.38-1.156.479-.46.11-.95.11-1.928.11H13.15c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216v-5.2Z"
              fillRule="nonzero"
              opacity=".12"
            />
            <path d="M13.117 6H18.383c1.092 0 1.958 0 2.655.057.714.058 1.317.18 1.869.46a4.75 4.75 0 0 1 2.075 2.077c.281.55.403 1.154.461 1.868.057.697.057 1.563.057 2.655V18.193c0 .888 0 1.461-.131 2.009a4.75 4.75 0 0 1-.569 1.373c-.294.48-.7.885-1.328 1.514l-.066.066-.251.25-.066.067c-.629.629-1.034 1.034-1.514 1.328a4.75 4.75 0 0 1-1.373.569c-.548.131-1.12.131-2.01.131h-5.075c-1.092 0-1.958 0-2.655-.057-.714-.058-1.317-.18-1.868-.46a4.75 4.75 0 0 1-2.076-2.076c-.281-.552-.403-1.155-.461-1.869C6 20.341 6 19.475 6 18.383V13.117c0-1.092 0-1.958.057-2.655.058-.714.18-1.317.46-1.868a4.75 4.75 0 0 1 2.077-2.076c.55-.281 1.154-.403 1.868-.461C11.159 6 12.025 6 13.117 6Zm-2.533 1.552c-.62.05-1.005.147-1.31.302a3.25 3.25 0 0 0-1.42 1.42c-.155.305-.251.69-.302 1.31-.051.63-.052 1.434-.052 2.566v5.2c0 1.133 0 1.937.052 2.566.05.62.147 1.005.302 1.31a3.25 3.25 0 0 0 1.42 1.42c.305.155.69.251 1.31.302.63.051 1.434.052 2.566.052h4.949c.377 0 .667 0 .901-.006V22.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.202-1.202c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03h1.074c.005-.234.006-.524.006-.901V13.15c0-1.132 0-1.937-.052-2.566-.05-.62-.147-1.005-.302-1.31a3.25 3.25 0 0 0-1.42-1.42c-.305-.155-.69-.251-1.31-.302-.63-.051-1.433-.052-2.566-.052h-5.2c-1.132 0-1.937 0-2.566.052ZM23.68 20.5h-.73c-.572 0-.957 0-1.252.025-.288.023-.425.065-.515.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.73c.1-.048.197-.101.291-.159.31-.19.586-.459 1.303-1.176l.251-.25c.717-.718.986-.993 1.176-1.304.058-.094.11-.191.159-.291ZM10 10.75a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75Zm.75 3.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6ZM10 18.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
